import * as actions from "./actions";
import NeedAuthorization from "./components/NeedAuthorization";

export default {
  actions
};

export { NeedAuthorization };